import styled from 'styled-components'
import { StyledPendingPayment } from './pending-payment'
import { breakpoints } from '../../../../../constants'

export const StyledContent = styled.div`
	display: flex;
	flex-direction: column;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
	}

	& > * {
		flex: 1;
	}

	${StyledPendingPayment} {
		margin-bottom: 4rem;
	}
`
